import { Injectable } from '@angular/core';
import { UserRepository } from '../repositories/user.repository';
import { Http } from '@angular/http';
import * as storage from '../helpers/localstorage';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BootConstants } from '../boot.constants';
import { TokenHttp, IToken } from './tokenhttp.service';
import { Observable } from 'rxjs';
import { CarrierRepository } from '../repositories/carrier.repository';
import { LocationRepository } from '../repositories/location.repository';
import { TourRepository } from '../repositories/tour.repository';
import { DriverRepository } from '../repositories/driver.repository';
import { DeliveryRepository } from '../repositories/delivery.repository';
import { PickupRepository } from '../repositories/pickup.repository';
import { CarrierLocationRepository } from '../repositories/carrier-location.repository';
import { CarrierTourRepository } from '../repositories/carrier-tour.repository';
import { CarrierDriverRepository } from '../repositories/carrier-driver.repository';
import { DeliveryMessageRepository } from '../repositories/delivery-message.repository';
import { ProductRepository } from '../repositories/product.repository';
import { InvoiceRepository } from '../repositories/InvoiceRepository';

@Injectable()
export class DataService {

  private _tokenName: string = "usertoken";
  private _identityUrl: string = BootConstants.identityServiceEndpoint;

  private _clientId: string = "miljoeServiceWebClient";
  private _clientSecret: string = "8743b1e6-a74b-465b-810d-90373754e0be-ddea4c9f-70de-4086-a678-35cd2d1a1f7a";
  private _clientScopes: string[] = ["MiljoeServiceApi", "offline_access"];

  constructor(
    private router: Router,
    private http: Http,
    private tokenHttp: TokenHttp,
    public user: UserRepository,
    public carrier: CarrierRepository,
    public location: LocationRepository,
    public carrierLocation: CarrierLocationRepository,
    public carrierTour: CarrierTourRepository,
    public carrierDrivers: CarrierDriverRepository,
    public tour: TourRepository,
    public deliveryMessages: DeliveryMessageRepository,
    public driver: DriverRepository,
    public delivery: DeliveryRepository,
    public pickup: PickupRepository,
    public invoice: InvoiceRepository,
    public products: ProductRepository
  ) {

    this.tokenHttp.start(this._identityUrl, this._clientId, this._clientSecret,
      storage.get(this._tokenName), this._clientScopes);

    this.tokenHttp.tokenChanged.subscribe((token?: IToken) => {
      storage.set(this._tokenName, token);
    });

  }

  public userIsValid() {
    return this.tokenHttp.token !== null;
  }

  get userRole() {
    if (this.userIsValid()) {
      return {
        isCarrier: this.tokenHttp.token.info.Role === "Carrier",
        isAdmin: this.tokenHttp.token.info.Role === "Admin"
      }
    }

    return { isCarrier: false, isAdmin: false };
  }

  get userCarrierId() {
    if (this.userIsValid()) {
      return parseInt(this.tokenHttp.token.info.CarrierId);
    }

    return null;
  }

  public tryLogin(username: string, password: string): Observable<IToken> {
    return this.tokenHttp.login(username, password);
  }

  public logOff() {
    this.tokenHttp.revoke().subscribe(() => {
      this.router.navigateByUrl("/login");
    });
  }

  public getTokenInfo() {
    return this.tokenHttp.token ? this.tokenHttp.token.info : {};
  }
}
